import { Tag } from 'antd';

type ProjectActiveBadgeProps = {
    isActive: boolean;
};

export const ProjectActiveBadge = ({ isActive }: ProjectActiveBadgeProps) => {
    if (isActive) return null;

    return (
        <Tag
            color="error"
            style={{
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: 0.5,
                padding: '0 6px',
                lineHeight: '18px',
                textTransform: 'uppercase',
                borderRadius: 4,
                flexShrink: 0,
            }}
        >
            Відключено
        </Tag>
    );
};
